<template>
    <div>
        <b-row>
            <b-col sm="8">
                <p class="mb-0"><strong>{{ artistPrint(item) }}</strong>: {{ titlePrint(item) }} {{ item.release.label.name }} {{ item.release.label.catalogNo }}</p>
                <!--<p class="mb-0"><strong>{{ title(item) }}</strong></p>-->
                <!--<p class="mb-0">{{ item.release.label.name }} {{ item.release.label.catalogNo }}, {{ format(item.release.media) }}</p>-->
                <p class="mb-0">{{ formatPrint(item.release.media) }}</p>
                <p class="mb-0"><em>{{ pressingPrint(item).join(', ') }}</em></p>
                <p class="mb-0"><em>{{ notesPrint(item).join(', ') }}</em></p>
            </b-col>

            <b-col>
                <div v-for="(c, index) in conditionsPrint(item.listing)" v-bind:key="'condition-' + index">
                    <b-row>
                        <b-col><p>{{ item.itemId }}_{{ item.listingIndex + 1 }}</p></b-col>
                        <b-col><p>{{ c.grade }} <span v-if="c.subject && c.subject != 'Item'">{{ c.subject }}</span></p></b-col>
                        <b-col>
                            <p>{{ item.listing.count }}</p>
                        </b-col>
                        <b-col>
                            <p>{{ item.listing.location }}</p>
                        </b-col>
                    </b-row>


                    <!--<b-row v-if="c.notes">-->
                        <!--<b-col>-->
                            <!--<em>{{ c.notes.join(', ') }}</em>-->
                        <!--</b-col>-->
                    <!--</b-row>-->
                </div>
                <!--<b-row>-->
                    <!--<b-col sm="5">-->
                        <!--<span>Price</span>-->
                    <!--</b-col>-->

                    <!--<b-col class="ml-auto">${{ item.listing.price }}</b-col>-->
                <!--</b-row>-->

            </b-col>
        </b-row>
    </div>
</template>

<script>
    import printItemMixin from "../../builders/printItem";

    export default {
        name: "PrintItem",
        props: [ 'item' ],
        mixins: [ printItemMixin ],
        methods: {
            async mounted() {
                this.inventoryItem = await this.getItem(this.item.details.itemId);
            },
            imageSrc(images) {
                return `${process.env.VUE_APP_IMAGES_URL}${images[0].url}`;
            }
        },
    }
</script>

<style scoped>
    span {
        color: grey;
    }
</style>